module.exports = __webpack_public_path__ + "static/media/net.5a4913c7.jpg";